import { ServicesURL } from "@utils/utilsApi";
import { DynamicFilterValue } from "@components/DynamicFilterCst/types";

export type CatalogEntityType = "activity" | "course" | "path";

export const CATALOG_URL_BY_TYPE: Record<CatalogEntityType, string> = {
  activity: ServicesURL.getActivities,
  course: ServicesURL.getCoursesAssociation,
  path: ServicesURL.getPaths,
};

export const CATALOG_AGGREGATED_URL = ServicesURL.getAggregatedLO;

export const mapAggregatedType = (type?: string): CatalogEntityType => {
  const normalized = (type || "").toLowerCase();
  if (normalized === "course") return "course";
  if (normalized === "path") return "path";
  return "activity";
};

export type TabKey = "all" | "activities" | "courses" | "paths";

export interface DraftDataEnvelope {
  type: CatalogEntityType;
  wizard: Record<string, any>;
}

export interface DraftListItem {
  id: number;
  corporate_id: number;
  lo_type: string;
  title: string | null;
  created_by: number;
  updated_by: number | null;
  creation_date: string;
  update_date: string;
  is_draft: boolean;
  data?: Record<string, any> & { __draft?: DraftDataEnvelope };
}

export const draftEntityType = (draft: DraftListItem): CatalogEntityType => {
  const envelopeType = draft.data?.__draft?.type;
  if (envelopeType) return envelopeType;
  const lo = (draft.lo_type || "").toUpperCase();
  if (lo === "COURSE") return "course";
  if (lo === "PATH") return "path";
  return "activity";
};

export type FieldValue = DynamicFilterValue;

export interface CatalogTabFilters {
  search?: string;
  fieldFilters?: Record<string, FieldValue>;
  sort?: string | null;
  page?: number;
}

export interface CatalogMeta {
  activeTab?: TabKey;
}

export interface SelectedLOItem {
  id: number;
  title: string;
  type: string;
  kind: "activity" | "course";
  entity: Record<string, any>;
  locked?: boolean;
}
